export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL ?? 'https://sitrack-api-dev.azurewebsites.net/api';
export const FASTFIELD_DISPATCH_URL =
  process.env.REACT_APP_FASTFIELD_DISPATCH_URL ?? 'https://si-track-processor.azurewebsites.net/api';

export const FASTFIELD_RECALL_URL =
  process.env.REACT_APP_FASTFIELD_RECALL_URL ?? 'https://si-track-processor.azurewebsites.net/api';

export const QUICK_BOOK_URL = process.env.REACT_APP_QUICKBOOK_URL ?? 'https://si-track-processor.azurewebsites.net/api';

export const ZIPCODE_FORMAT = '#####-####';
export const PHONENUMBER_FORMAT = '(###) ###-####';

export enum StorageKey {
  AUTH_TOKEN = 'AUTH_TOKEN',
  REFRESH_TOKEN = 'REFRESH_TOKEN',
}
